/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';

import Heading, { HeadingVariant, HeadingScope } from 'src/components/Heading';
import Text from 'src/components/Text';
import { colors } from 'src/themes/colors';

const baseLinkStyles = css`
  color: ${colors.blue};
  font-weight: 700;
  position: relative;
  text-align: center;

  &:after {
    background: none repeat scroll 0 0 transparent;
    background-color: ${colors.blue};
    bottom: 0;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }

  &:hover:after {
    width: 100%;
  }
`;

const StyledLink = styled(Link)`
  ${baseLinkStyles}
`;

const StyledExternalLink = styled.a`
  ${baseLinkStyles}
`;

const CustomHeading1 = (props: any) => (
  <Heading variant={HeadingVariant.ALFA} {...props} />
);
const CustomHeading2 = (props: any) => (
  <HeadingScope>
    <Heading variant={HeadingVariant.BRAVO} {...props} />
  </HeadingScope>
);
const CustomHeading3 = (props: any) => (
  <HeadingScope>
    <Heading variant={HeadingVariant.CHARLIE} {...props} />
  </HeadingScope>
);
const CustomHeading4 = (props: any) => (
  <HeadingScope>
    <Heading variant={HeadingVariant.DELTA} {...props} />
  </HeadingScope>
);
const CustomHeading5 = (props: any) => (
  <HeadingScope>
    <Heading variant={HeadingVariant.ECHO} {...props} />
  </HeadingScope>
);
const CustomHeading6 = (props: any) => (
  <HeadingScope>
    <Heading variant={HeadingVariant.FOXTROT} {...props} />
  </HeadingScope>
);
const CustomParagraph = (props: any) => <Text {...props} />;

const CustomLink = props => {
  const href = props.href;
  const isInternalLink = href && (href.startsWith('/') || href.startsWith('#'));

  if (isInternalLink) {
    return <StyledLink to={href} {...props} />;
  }
  return (
    <StyledExternalLink
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      {...props}
    />
  );
};

const MDXComponents = {
  h1: CustomHeading1,
  h2: CustomHeading2,
  h3: CustomHeading3,
  h4: CustomHeading4,
  h5: CustomHeading5,
  h6: CustomHeading6,
  p: CustomParagraph,
  a: CustomLink,
};

export default MDXComponents;
